import {
  CONTENT_WORD_INIT_GAME,
  CONTENT_WORD_SELECT_ANSWER,
  CONTENT_WORD_TIMES_UP,
  CONTENT_WORD_END_RESPONSE,
  CONTENT_WORD_START_PLAY,
  CONTENT_WORD_IMPORT,
  CONTENT_WORD_COUNTDOWN,
  CONTENT_WORD_SHUFFLE,
  CONTENT_WORD_SELECT_ROUND,
  CONTENT_WORD_SET_ANSWER,
  CONTENT_WORD_SET_DISPLAY,
  CONTENT_WORD_PLAY_AGAIN,
} from "./../actions/actionIdentifiers";
import { INTRO_STAGE, PLAY_STAGE, FINISH_STAGE } from "./stateIdentifiers";

export interface ContentWordState {
  stage: string;
  time: number;
  score_per_question: number;
  incorrect_reduce_score: number;
  round: number;
  score: number;
  words: string[];
  specialWords: any;
  display: string[];
  answer: string;
  selected: number;
  response: string;
}

const initialState: ContentWordState = {
  stage: INTRO_STAGE,
  // stage: PLAY_STAGE,
  // stage: FINISH_STAGE,
  time: null,
  score_per_question: null,
  incorrect_reduce_score: null,
  round: null,
  score: null,
  words: [],
  specialWords: null,
  display: [],
  answer: null,
  selected: null,
  response: null,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CONTENT_WORD_START_PLAY:
      return { ...state, stage: PLAY_STAGE };
    case CONTENT_WORD_IMPORT:
      return { ...state, ...payload };
    case CONTENT_WORD_SHUFFLE:
      return { ...state, words: payload };
    case CONTENT_WORD_INIT_GAME:
      return {
        ...state,
        score: payload.score,
        time: payload.time,
        score_per_question: payload.score_per_question,
        incorrect_reduce_score: payload.incorrect_reduce_score,
      };

    case CONTENT_WORD_SELECT_ROUND:
      return { ...state, round: payload };
    case CONTENT_WORD_COUNTDOWN:
      return { ...state, time: payload };
    case CONTENT_WORD_SET_ANSWER:
      return { ...state, answer: payload };
    case CONTENT_WORD_SET_DISPLAY:
      return { ...state, display: payload };
    case CONTENT_WORD_SELECT_ANSWER:
      return { ...state, ...payload };
    case CONTENT_WORD_TIMES_UP:
      return { ...state, stage: FINISH_STAGE };
    case CONTENT_WORD_END_RESPONSE:
      return { ...state, selected: null, response: null };
    case CONTENT_WORD_PLAY_AGAIN:
      return { ...state, stage: PLAY_STAGE };
    // return { ...initialState, stage: INTRO_STAGE, words: payload };
    default:
      return state;
  }
};
